import { Deserializable } from '../protocols/deserializable';
import { RelationshipStatus } from '../enum/shared/relationship-status';
import { MemberRelationshipStatus } from '../users/dto/member-relationship-status';
import { RelationshipStatusSubmissionSpouse } from './relationship-status-submission-spouse';
import { RelationshipStatusType } from '../types/dto/relationship-status-type';

export class RelationshipStatusSubmissionData implements Deserializable {
  public relationshipStatusId: RelationshipStatus | null = null;
  public effectiveDate: string | null = null;
  public endDate: string | null = null;
  public relationshipStatus: RelationshipStatusType | null = null;
  public spouse: RelationshipStatusSubmissionSpouse | null = null;

  public onDeserialize() {
    const Deserialize = window.injector.Deserialize;
    if (this.relationshipStatus) {
      Deserialize.instanceOf(MemberRelationshipStatus, this.relationshipStatus);
    }
    if (this.spouse) {
      this.spouse = Deserialize.instanceOf(RelationshipStatusSubmissionSpouse, this.spouse);
    }
  }
}
